<script setup lang="ts"></script>

<template>
  <div class="dropdown-custom-item label-m" data-is-final="false">
    <slot></slot>
  </div>
</template>

<style scoped>
.dropdown-custom-item {
  display: inline-block;
  min-width: 100%;
  border: 0;
  border-bottom: 1px solid var(--color-stroke-background-primary);
  background-color: var(--color-background-primary);
  letter-spacing: -0.015em;
  line-height: calc(var(--font-size-sm) * 1.2);
  text-align: left;
  white-space: nowrap;

  &:first-child {
    border-radius: var(--radius-xs) var(--radius-xs) 0 0;
  }

  &:last-child {
    border-radius: 0 0 var(--radius-xs) var(--radius-xs);
    border-bottom: 0;
  }

  .icon.left:has(+ .label) {
    padding-right: var(--spacing-8);
  }

  .label + .icon.right {
    padding-left: var(--spacing-8);
  }
}
</style>
